const animations = [
    {
        key: 'idle_notalk_01',
        file: 'ava_idle_notalk_01',
        length: 2090,
        group: ''
    },
    {
        key: 'ava_idle_talk_01',
        file: 'ava_idle_talk_01',
        length: 2090,
        group: ''
    },
    {
        key: 'turn_talk_01',
        file: 'ava_turn_talk_01',
        length: 3020,
        group: ''
    },
    {
        key: 'turn_talk_02',
        file: 'ava_turn_talk_02',
        length: 3060,
        group: ''
    },
    {
        key: 'turn_talk_03',
        file: 'ava_turn_talk_03',
        length: 3060,
        group: ''
    },
    {
        key: 'turn_talk_04',
        file: 'ava_turn_talk_04',
        length: 4020,
        group: ''
    },
    {
        key: 'gesture_talk_01',
        file: 'ava_gesture_talk_01',
        length: 4020,
        group: ''
    },
    {
        key: 'gesture_talk_02',
        file: 'ava_gesture_talk_02',
        length: 3050,
        group: ''
    },
    {
        key: 'gesture_talk_03',
        file: 'ava_gesture_talk_03',
        length: 3000,
        group: ''
    },
    {
        key: 'gesture_talk_04',
        file: 'ava_gesture_talk_04',
        length: 4020,
        group: ''
    },
    {
        key: 'gesture_talk_05',
        file: 'ava_gesture_talk_05',
        length: 2090,
        group: ''
    },
    {
        key: 'gesture_talk_06',
        file: 'ava_gesture_talk_06',
        length: 3000,
        group: ''
    },
    {
        key: 'gesture_talk_07',
        file: 'ava_gesture_talk_07',
        length: 4040,
        group: ''
    },
    {
        key: 'gesture_talk_08',
        file: 'ava_gesture_talk_08',
        length: 3020,
        group: ''
    },
    {
        key: 'gesture_talk_09',
        file: 'ava_gesture_talk_09',
        length: 4060,
        group: ''
    }
]

const animationsAsObject = {
    gesture_talk_01:{ key: "gesture_talk_01", file: "ava_gesture_talk_01", length: 4020, group: "" },
    gesture_talk_02:{ key: "gesture_talk_02", file: "ava_gesture_talk_02", length: 3050, group: "" },
    gesture_talk_03:{ key: "gesture_talk_03", file: "ava_gesture_talk_03", length: 3000, group: "" },
    gesture_talk_04:{ key: "gesture_talk_04", file: "ava_gesture_talk_04", length: 4020, group: "" },
    gesture_talk_05:{ key: "gesture_talk_05", file: "ava_gesture_talk_05", length: 2090, group: "" },
    gesture_talk_06:{ key: "gesture_talk_06", file: "ava_gesture_talk_06", length: 3000, group: "" },
    gesture_talk_07:{ key: "gesture_talk_07", file: "ava_gesture_talk_07", length: 4040, group: "" },
    gesture_talk_08:{ key: "gesture_talk_08", file: "ava_gesture_talk_08", length: 3020, group: "" },
    gesture_talk_09:{ key: "gesture_talk_09", file: "ava_gesture_talk_09", length: 4060, group: "" },
    idle_notalk_01:{ key: "idle_notalk_01", file: "ava_idle_notalk_01", length: 2090, group: "" },
    turn_talk_01:{ key: "turn_talk_01", file: "ava_turn_talk_01", length: 3020, group: "" },
    turn_talk_02:{ key: "turn_talk_02", file: "ava_turn_talk_02", length: 3060, group: "" },
    turn_talk_03:{ key: "turn_talk_03", file: "ava_turn_talk_03", length: 3060, group: "" },
    turn_talk_04:{ key: "turn_talk_04", file: "ava_turn_talk_04", length: 4020, group: "" }
}

//const arrayToObject = (array, keyField) =>
//    array.reduce((obj, item) => {
//        obj[item[keyField]] = item
//        return obj
//    }, {})

//const animationsObject = arrayToObject(animations, "key")

export default {
    getAllAnimations(cb) {
        cb(animations);
    },
    animationsAsObject
}
